module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp3_8004.36b16c33.png";